import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { LoadingButton } from "@mui/lab";
import { Accordion, Button } from "@mui/material";
import WebpImage from "@src/component/base/WebpImage";
import { Empty, GroupA } from "@src/ruix";

export const FAQAnswerDiv2 = styled.div`
	color: var(--desc-gray);
	font-size: 20px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 24px */
	letter-spacing: -0.64px;
`;

export const FAQAnswerDiv = styled.div`
	color: var(--desc-gray);
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 24px */
	letter-spacing: -0.64px;

	@media screen and (max-width: 1023px) {
		font-size: 14px;
	}
`;

export const CtaImageBox = styled.div`
	position: absolute;
	padding: 8px;
	border-radius: 4px;
	background: #f6f7f8;

	box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.04);
`;

export const MainCtaButton = styled(Button)`
	display: flex;
	padding: 12px 24px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	border-radius: 12px;
	color: #fff;
	text-align: center;
	font-size: 24px;
	font-style: normal;
	font-weight: 700;
	line-height: 130%; /* 31.2px */
	letter-spacing: -0.96px;
	width: 280px;
	box-shadow: 0px 6px 20px 0px rgba(56, 124, 246, 0.2);
	transition: transform 0.2s ease, box-shadow 0.2s ease !important;

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0px 10px 28px 0px rgba(56, 124, 246, 0.3) !important;
	}
`;

export const MainCtaButtonOutlined = styled(Button)`
	display: flex;
	padding: 12px 24px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	border-radius: 4px;
	color: var(--primary);
	text-align: center;
	font-size: 24px;
	font-style: normal;
	font-weight: 700;
	line-height: 130%; /* 31.2px */
	letter-spacing: -0.96px;
	background-color: white;
	border: 1px solid var(--primary);
	width: 280px;

	@media screen and (max-width: 1023px) {
		display: flex;
		padding: 12px 24px;
		justify-content: center;
		align-items: center;
		gap: 10px;
		border-radius: 4px;
		text-align: center;
		font-size: 16px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 31.2px */
		letter-spacing: -0.96px;
		width: 200px;
	}
`;

export const ExpertMainCtaButton = styled(Button)`
	display: flex;
	padding: 12px 24px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	border-radius: 4px;
	border-color: var(--card-bg);
	color: var(--card-bg);
	text-align: center;
	font-size: 24px;
	font-style: normal;
	font-weight: 700;
	line-height: 130%; /* 31.2px */
	letter-spacing: -0.96px;
	background-color: white;

	&:hover {
		background-color: var(--bg-white);
		border-color: black;
	}
`;

export const ExpertMainCtaButtonMobile = styled(Button)`
	display: flex;
	padding: 12px 24px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	border-radius: 4px;
	border-color: var(--card-bg);
	color: var(--card-bg);
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 130%; /* 31.2px */
	letter-spacing: -0.96px;
	background-color: white;

	&:hover {
		background-color: var(--bg-white);
		border-color: black;
	}
`;

export const BlogCtaButton = styled(Button)`
	display: flex;
	padding: 12px 20px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	min-width: fit-content;
	border-radius: 10px;
	background-color: var(--card-bg);
	box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.12);
	transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease !important;

	&:hover {
		background-color: var(--bg);
		transform: translateY(-2px);
		box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.2) !important;
	}

	color: white;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 800;
	line-height: 130%; /* 20.8px */
	letter-spacing: -0.48px;
`;

export const MainCtaContentsInner = styled.div`
	gap: 0px;

	.cta-title-box {
		span {
			color: var(--card-bg);
			text-align: center;
			font-size: 48px;
			font-style: normal;
			font-weight: 800;
			line-height: 116%; /* 55.68px */
			letter-spacing: -1.92px;
		}
		.blue {
			color: var(--primary);
		}
	}
`;

const slideUpFade = keyframes`
	from {
		transform: translateY(16px);
		opacity: 0;
	}
	to {
		transform: translateY(0);
		opacity: 1;
	}
`;

export const RollingTextSpan = styled.span`
	display: inline-block;
	vertical-align: bottom;
	position: relative;
	top: 1px;
	margin: 0 1px 0 6px;
	animation: ${slideUpFade} 0.5s ease forwards;
`;

export const ExpertCtaContentsInner = styled.div`
	gap: 20px;

	.cta-label {
		color: white;
		text-align: center;
		font-size: 20px;
		font-style: normal;
		font-weight: 800;
		line-height: 116%; /* 23.2px */
		letter-spacing: -0.8px;
	}

	.cta-title-box {
		span {
			color: white;
			text-align: center;
			font-size: 48px;
			font-style: normal;
			font-weight: 800;
			line-height: 116%; /* 55.68px */
			letter-spacing: -1.92px;
		}
		.blue {
			color: var(--primary);
		}
	}
`;

export const ExpertCtaContentsInnerMobile = styled.div`
	gap: 20px;

	.cta-title-box {
		span {
			color: white;
			text-align: center;
			font-size: 36px;
			font-style: normal;
			font-weight: 800;
			line-height: 116%; /* 55.68px */
			letter-spacing: -1.92px;
		}
		.blue {
			color: var(--primary);
		}
	}

	.cta-label {
		color: white;
		text-align: center;
		font-size: 16px;
		font-style: normal;
		font-weight: 800;
		line-height: 116%; /* 18.56px */
		letter-spacing: -0.64px;
	}
`;

export const MainCtaContentsContainer = styled.div`
	padding-top: 120px;
	padding-bottom: 0px;
	width: 100%;
	position: relative;
`;

export const ExpertCtaContentsContainer = styled.div`
	padding-top: 120px;
	padding-bottom: 120px;
	width: 100%;
	position: relative;
	background-color: var(--card-bg);

	@media screen and (max-width: 1024px) {
		padding-top: 72px;
		padding-bottom: 72px;
	}
`;

export interface ProcessCardProps {
	imgSrc: string;
	title: string;
	subTitle: string;
}

export type WhyCardProps = ProcessCardProps;

export const WhyCardList = [
	{
		imgSrc: "/onepoint/images/renewal/why-section/why1.png",
		title: "정규직 채용이 부담스러워요",
		subTitle:
			"잘하는 마케터가 필요하나 파트타임을 원하거나,\n사업 변동성이 커서 유연한 고용이 필요할 때",
	},
	{
		imgSrc: "/onepoint/images/renewal/why-section/why2.png",
		title: "신규 전략 수립이 필요합니다",
		subTitle:
			"대행사가 깊이 고민해주지 않아서 아쉽거나,\n새로운 전략 수립이 필요하나 CMO가 없을 때",
	},
	{
		imgSrc: "/onepoint/images/renewal/why-section/why3.png",
		title: "내부 역량 강화를 원합니다",
		subTitle:
			"대표/임원이 직접 배워 시스템을 구축하고 싶거나, 내부 주니어 마케터의 사수가 필요할 때",
	},
	{
		imgSrc: "/onepoint/images/renewal/why-section/why4.png",
		title: "특정 전문성이 단기로 필요합니다",
		subTitle:
			"새로운 시도를 위해 특정 스킬/경험이 필요하거나, 기존 마케팅 방식과 시스템을 점검받고 싶을 때",
	},
];

export const WhyCard = (props: WhyCardProps) => {
	const { imgSrc, title, subTitle } = props;
	return (
		<WhyCardBox>
			<WebpImage
				style={{
					width: "56px",
					height: "56px",
				}}
				src={imgSrc}
				alt=""
			/>
			<GroupA order="column-start-start" gap={8}>
				<div className="title">{title}</div>
				<div className="subTitle">{subTitle}</div>
			</GroupA>
		</WhyCardBox>
	);
};

export const ProcessCardList = [
	{
		imgSrc: "/onepoint/images/renewal/process/process_1.png",
		title: "매칭 컨설팅",
		subTitle: "마케터 출신의 매칭 컨설턴트와 요청 업무에 대해 논의합니다.",
	},
	{
		imgSrc: "/onepoint/images/renewal/process/process_2.png",
		title: "최적 매칭",
		subTitle: "개별 기업의 특성과 니즈에 맞춘 최적 전문가를 추천받습니다.",
	},
	{
		imgSrc: "/onepoint/images/renewal/process/process_3.png",
		title: "인터뷰",
		subTitle: "화상 미팅을 통해 전문가의\n역량과 적극성을 검증합니다.",
	},
	{
		imgSrc: "/onepoint/images/renewal/process/process_4.png",
		title: "계약",
		subTitle: "계약 사항 협의를 완료하고 전문가와 업무를 시작합니다.",
	},
];

export const ExpertProcessCardList = [
	{
		imgSrc: "/onepoint/images/renewal/expert/why-section/document.png",
		title: "서류",
		subTitle: "경력, 이력, 과거 프로젝트\n경험을 제출합니다",
	},
	{
		imgSrc: "/onepoint/images/renewal/process/process_2.png",
		title: "역량 평가",
		subTitle: "실무 역량을 검증하기 위한\n과제 평가를 진행합니다",
	},
	{
		imgSrc: "/onepoint/images/renewal/process/process_3.png",
		title: "심층 면접",
		subTitle: "소프트 스킬을 검증하기 위한\n면접을 진행합니다",
	},
	{
		imgSrc: "/onepoint/images/renewal/process/process_4.png",
		title: "계약",
		subTitle: "원포인트와 계약을 체결하면\n전문가 풀에 등록됩니다",
	},
];

export const ExpertProcessCardListMobile = [
	{
		imgSrc: "/onepoint/images/renewal/expert/why-section/document.png",
		title: "서류",
		subTitle: "경력, 이력, 과거 프로젝트\n경험을 제출합니다",
	},
	{
		imgSrc: "/onepoint/images/renewal/process/process_2.png",
		title: "역량 평가",
		subTitle: "실무 역량을 검증하기 위한\n과제 평가를 진행합니다",
	},
	{
		imgSrc: "/onepoint/images/renewal/process/process_3.png",
		title: "심층 면접",
		subTitle: "소프트 스킬을 검증하기 위한\n면접을 진행합니다",
	},
	{
		imgSrc: "/onepoint/images/renewal/process/process_4.png",
		title: "계약",
		subTitle: "원포인트와 계약을 체결하면\n전문가 풀에 등록됩니다",
	},
];

export const ProcessCard = (props: ProcessCardProps) => {
	const { imgSrc, title, subTitle } = props;
	return (
		<ProcessCardBox>
			<WebpImage
				src={imgSrc}
				alt=""
				style={{
					width: "56px",
					height: "56px",
				}}
			/>
			<Empty space={16} />
			<div className="title">{title}</div>
			<Empty space={8} />
			<div className="subTitle">{subTitle}</div>
		</ProcessCardBox>
	);
};

export const ExpertProcessCard = (props: ProcessCardProps) => {
	const { imgSrc, title, subTitle } = props;
	return (
		<ExpertProcessCardBox>
			<WebpImage
				src={imgSrc}
				alt=""
				style={{
					width: "56px",
					height: "56px",
				}}
			/>
			<Empty space={16} />
			<div className="title">{title}</div>
			<Empty space={8} />
			<div className="subTitle">{subTitle}</div>
		</ExpertProcessCardBox>
	);
};

export const WhyCardBox = styled.div`
	display: flex;
	flex: 1;
	padding: 32px 20px;
	width: 488px;
	align-items: flex-start;
	gap: 16px;
	border-radius: 16px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	background: #fff;
	box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07);
	transition: transform 0.2s ease, box-shadow 0.2s ease;

	&:hover {
		transform: translateY(-4px);
		box-shadow: 0px 12px 32px 0px rgba(0, 0, 0, 0.12);
	}

	.title {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 24px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 31.2px */
		letter-spacing: -0.72px;
	}

	.subTitle {
		color: var(--desc-gray);
		font-family: Pretendard;
		font-size: 20px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 30px */
		letter-spacing: -0.8px;
	}
`;

export const ExpertProcessCardBox = styled.div`
	display: flex;
	padding: 32px 20px;
	flex-direction: column;
	align-items: flex-start;
	flex: 1 0 0;
	border-radius: 4px;
	width: 232px;

	@media screen and (max-width: 1023px) {
		width: 100%;
		align-items: center;
		justify-content: center;
	}

	.title {
		color: var(--card-bg);
		font-size: 24px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 31.2px */
		letter-spacing: -0.72px;
	}

	.subTitle {
		color: var(--desc-gray);
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 30px */
		letter-spacing: -0.8px;
	}
`;

export const ProcessCardBox = styled.div`
	display: flex;
	padding: 32px 20px;
	flex-direction: column;
	align-items: flex-start;
	flex: 1 0 0;
	border-radius: 16px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	width: 232px;
	background: #fff;
	box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07);
	transition: transform 0.2s ease, box-shadow 0.2s ease;

	&:hover {
		transform: translateY(-4px);
		box-shadow: 0px 12px 32px 0px rgba(0, 0, 0, 0.12);
	}

	.title {
		color: var(--card-bg);
		font-size: 24px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 31.2px */
		letter-spacing: -0.72px;
	}

	.subTitle {
		color: var(--desc-gray);
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 30px */
		letter-spacing: -0.8px;
	}
`;

export const ConsultantCardListBox = styled.div`
	width: 200px;
	flex: 0;
	flex-shrink: 0;
	max-width: 500px;
`;

export const ReviewCard = styled.div`
	display: flex;
	padding: 32px 20px;
	flex-direction: column;
	align-items: flex-start;
	gap: 16px;
	flex: 1 0 0;
	border-radius: 16px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	background: #fff;
	box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.04);
	transition: transform 0.2s ease, box-shadow 0.2s ease;

	&:hover {
		transform: translateY(-4px);
		box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
	}

	.title {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 24px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 31.2px */
		letter-spacing: -0.72px;
		height: 60px;
		width: 100%;
	}

	.desc {
		color: var(--desc-gray);
		font-family: Pretendard;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 24px */
		letter-spacing: -0.64px;
		height: 120px;
	}

	.img {
		height: 30px;
		flex-shrink: 0;
		margin-top: 10px;
		margin-bottom: 10px;
	}

	.name {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 16px;
		font-style: normal;
		font-weight: 800;
		line-height: 130%; /* 20.8px */
		letter-spacing: -0.48px;
	}
`;

export const ExpertReviewCard = styled.div`
	display: flex;
	padding: 32px 20px;
	flex-direction: column;
	align-items: flex-start;
	gap: 16px;
	flex: 1 0 0;
	border-radius: 16px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	background: #fff;
	box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07);
	transition: transform 0.2s ease, box-shadow 0.2s ease;

	&:hover {
		transform: translateY(-4px);
		box-shadow: 0px 12px 32px 0px rgba(0, 0, 0, 0.12);
	}

	.title {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 24px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 31.2px */
		letter-spacing: -0.72px;
		height: 60px;
		width: 100%;
	}

	.desc {
		color: var(--desc-gray);
		font-family: Pretendard;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 24px */
		letter-spacing: -0.64px;
		height: 140px;
	}

	.name {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 16px;
		font-style: normal;
		font-weight: 800;
		line-height: 130%; /* 20.8px */
		letter-spacing: -0.48px;
		gap: 4px;

		.name-gray {
			color: var(--desc-gray);
		}
	}
`;

export const ConsultantCard = styled.div`
	display: flex;
	padding: 30px 2px 13px 2px;
	flex-direction: column;
	justify-content: flex-end;
	align-items: center;
	gap: 12px;
	border-radius: 16px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	background: #fff;
	box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07);
	transition: transform 0.2s ease, box-shadow 0.2s ease;

	&:hover {
		transform: translateY(-4px);
		box-shadow: 0px 12px 32px 0px rgba(0, 0, 0, 0.12);
	}

	.profile-img {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		object-fit: cover;
	}

	.name {
		color: var(--card-bg);
		text-align: center;
		font-family: Pretendard;
		font-size: 24px;
		font-style: normal;
		font-weight: 800;
		line-height: 120%; /* 28.8px */
		letter-spacing: -0.96px;
	}

	.desc {
		color: var(--desc-gray);
		text-align: center;
		font-family: Pretendard;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 24px */
		letter-spacing: -0.64px;
	}
`;

export const MainContentsContainer = styled.div`
	gap: 160px;

	.ci-list .swiper-wrapper {
		transition-timing-function: linear !important;
		/* 추가: 모바일에서 드래그 시 끊김 방지 */
		-webkit-transition-timing-function: linear !important;
	}

	.hidden {
		opacity: 0;
		pointer-events: none;
	}

	.floating {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: 10px;
		position: fixed;
		bottom: 50px;
		left: 50%;
		transform: translateX(-50%);
		z-index: 1000;
	}

	.floating-btn-apply,
	.floating-btn-consult {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		font-size: 18px;
		font-weight: bold;
		padding: 10px 10px;
		padding-right: 5px;
		border-radius: 30px;
		width: 240px;
		cursor: pointer;
		height: 60px;
		box-shadow: 0 19px 38px rgba(0, 0, 0, 0.5);
		transition: 0.3s ease;

		&:hover {
			transform: translateY(-4px);
			box-shadow: 0 24px 48px rgba(0, 0, 0, 0.6);
		}
	}

	.floating-btn-apply {
		background-color: var(--primary);
		color: white;
	}

	.floating-btn-consult {
		background-color: white;
		color: var(--primary);
	}

	@media screen and (max-width: 768px) {
		.floating-btn-apply,
		.floating-btn-consult {
			width: 160px;
			height: 50px;
			border-radius: 50px;
			font-size: 16px;
		}
	}
`;

export const ExpertMainContentsContainerMobile = styled.div`
	gap: 80px;

	.hidden {
		opacity: 0;
		pointer-events: none;
	}

	#floating-btn {
		position: fixed;
		bottom: 50px;
		left: 50%;
		transform: translateX(-50%);
		z-index: 1000;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		background-color: var(--primary);
		font-size: 18px;
		font-weight: bold;
		color: white;
		padding: 10px 10px;
		padding-right: 5px;
		border-radius: 30px;
		width: 230px;
		cursor: pointer;
		height: 60px;
		box-shadow: 0 19px 38px rgba(0, 0, 0, 0.5);
		transition: 0.3s ease;
	}

	@media screen and (max-width: 768px) {
		#floating-btn {
			width: 160px;
			height: 50px;
			border-radius: 50px;
			font-size: 16px;
		}
	}
`;

export const ContentsContainer = styled.section`
	width: 100%;
	max-width: 1024px;
	padding: 0 20px;
	position: relative;
	margin: 0 auto;
`;

export const ContentsContainerMobile = styled.section`
	width: 100%;
	max-width: 1024px;
	padding: 0 8px;
	position: relative;
`;

export const SectionTitle = styled.div`
	color: var(--card-bg);
	text-align: center;
	font-size: 40px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%; /* 48px */
	letter-spacing: -1.6px;

	@media screen and (max-width: 1023px) {
		font-size: 24px;
	}
`;

export const SectionTitlePrimary = styled.div`
	color: var(--primary);
	text-align: left;
	font-size: 32px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%; /* 48px */
	letter-spacing: -1.6px;

	@media screen and (max-width: 1023px) {
		font-size: 24px;
	}
`;

export const SectionTitleMobile = styled.div`
	color: var(--card-bg);
	text-align: center;
	font-size: 24px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%; /* 48px */
	letter-spacing: -1.6px;
`;

export const SectionLargeTitle = styled.div`
	color: var(--primary);
	font-size: 40px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%; /* 48px */
	letter-spacing: -1.6px;
`;

export const SectionTitleLeft = styled.div`
	color: var(--card-bg);
	font-size: 40px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%; /* 48px */
	letter-spacing: -1.6px;
`;

export const SectionTitleLeftDirect = styled.div`
	color: var(--card-bg);
	font-size: 28px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%; /* 48px */
	letter-spacing: -1.6px;
`;

export const SectionSubTitle = styled.div`
	color: var(--desc-gray);
	text-align: center;
	font-size: 20px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 30px */
	letter-spacing: -0.8px;
`;

export const SectionSubTitleMobile = styled.div`
	color: var(--desc-gray);
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 30px */
	letter-spacing: -0.8px;
`;

export const SectionSmallTitle = styled.div`
	color: var(--card-bg);
	text-align: center;
	font-size: 32px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%; /* 38.4px */
	letter-spacing: -1.28px;

	> span {
		color: var(--primary);
	}
`;

export const HowtoSectionSmallTitle = styled.div`
	color: var(--card-bg);
	text-align: center;
	font-size: 24px;
	font-style: normal;
	font-weight: 700;
	line-height: 120%; /* 28.8px */
	letter-spacing: -0.72px;

	> span {
		color: var(--primary);
	}
`;

export const SectionSmallSubTitle = styled.div`
	color: var(--primary);
	text-align: left;
	font-size: 20px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 30px */
	letter-spacing: -0.8px;
	max-width: 816px;
`;

export const SectionSmallSubTitle2 = styled.div`
	color: var(--card-bg);
	text-align: left;
	width: 100%;
	font-size: 20px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 30px */
	letter-spacing: -0.8px;
	max-width: 816px;
`;

export interface ProfileData {
	name: string;
	job: string;
	introduction: string;
	tagList: string[];
	skillList: string[];
	imageUrl: string;
	profileUrl: string;
}

export const WhyOnePointBox = styled.div`
	padding: 56px 80px;
	background-color: var(--bg-white);
	width: 100%;

	@media screen and (max-width: 768px) {
		padding: 20px 10px;
	}
`;

export const WhyOnePointDiv = styled.div`
	gap: 8px;
	.label {
		color: var(--primary);
		font-size: 20px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 26px */
		letter-spacing: -0.6px;
	}

	.title {
		color: var(--desc-gray);
		font-size: 32px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 41.6px */
		letter-spacing: -0.96px;

		.bold {
			color: var(--card-bg);
		}
	}

	.description {
		color: var(--desc-gray);
		font-size: 24px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 36px */
		letter-spacing: -0.96px;
	}

	@media screen and (max-width: 1023px) {
		.title {
			font-size: 24px;
		}

		.description {
			font-size: 20px;
		}
	}
`;

export const profileDataArray: ProfileData[] = [
	{
		name: "hani",
		job: "콘텐츠·브랜드 마케터 7년차",
		introduction:
			"다양한 규모의 인하우스 경험을 바탕으로\n온·오프라인 브랜드 마케팅 전략과 실무를\n모두 수행하는 전략형 마케터",
		tagList: [
			"뷰티/화장품",
			"라이프스타일",
			"F&B",
			"SaaS"
		],
		skillList: [
			"Google",
			"Meta",
			"LinkedIn",
			"네이버",
			"카카오",
			"콘텐츠 기획"
		],
		imageUrl: "/onepoint/assets/images/main/profile/hani.jpg",
		profileUrl: "https://notion.1point.kr/expert/profile/hani"	
	},
	{
		"name": "강제인",
		"job": "콘텐츠 마케터 9년차",
		"introduction": "브랜드 맥락을 기반으로\n콘텐츠와 크리에이티브를 설계하고\n성과로 연결하는 콘텐츠 마케터",
		"tagList": ["여행/레저", "교육", "SaaS", "플랫폼"],
		"skillList": ["콘텐츠 기획/전략", "소재/상세 페이지 기획", "Figma", "Meta"],
		"imageUrl": "/onepoint/assets/images/main/profile/kangjane.jpg",
		"profileUrl": "https://notion.1point.kr/expert/profile/kangjane"
	},
	{
		name: "댄디라이언",
		job: "콘텐츠 마케터 14년차",
		introduction:
			"기획부터 디자인·제작까지 전 과정을 아우르며\n감각적인 콘텐츠로 브랜드 스토리를 만드는\n올인원 콘텐츠·브랜딩 마케터",
		tagList: [
			"레저",
			"여행/아웃도어/부동산",
			"스포츠/패션",
			"자동차"
		],
		skillList: [
			"바이럴 마케팅",
			"콘텐츠 마케팅",
			"Meta",
			"네이버 SNS"
		],
		imageUrl: "/onepoint/assets/images/main/profile/dandylion.jpg",
		profileUrl: "https://notion.1point.kr/expert/profile/dandylion"
	},
	{
		name: "루시",
		job: "퍼포먼스 마케터 9년차",
		introduction:
			"콘텐츠·브랜딩·퍼포먼스를 아우르는\n경험과 10명 규모 팀 리딩 경험을 보유한\n시니어 퍼포먼스 마케터",
		tagList: [
			"뷰티/화장품",
			"패션",
			"앱 ",
			"SNS",
			"글로벌"
		],
		skillList: [
			"Google",
			"Meta",
			"네이버",
			"카카오",
			"퍼포먼스 전략",
		],
		imageUrl: "/onepoint/assets/images/main/profile/lucy.jpg",
		profileUrl: "https://notion.1point.kr/expert/profile/lucy"
	},
	// {
	// 	name: "제이",
	// 	job: "그로스 마케터 11년차",
	// 	introduction:
	// 		"재미와 의미가 있는 일을 찾아\n문제를 정의하고 해결하는\n11년차 그로스 마케터",
	// 	tagList: ["커머스", "인사/비즈니스", "교육"],
	// 	skillList: ["마케팅전략", "데이터분석", "Meta", "Google"],
	// 	imageUrl: "/onepoint/assets/images/main/profile/jay.jpg",
	// 	profileUrl: "https://notion.1point.kr/expert/profile/jay",
	// },
	// {
	// 	name: "데이",
	// 	job: "퍼포먼스 마케터 10년차",
	// 	introduction: "Meta 전문, 커머스 전문\n10년차 퍼포먼스마케터\n\n",
	// 	tagList: ["패션", "홈리빙/생활용품", "유아동"],
	// 	skillList: ["Meta", "네이버", "카카오"],
	// 	imageUrl: "/onepoint/assets/images/main/profile/day.jpg",
	// 	profileUrl: "https://notion.1point.kr/expert/profile/day",
	// },
	{
		name: "M-J",
		job: "퍼포먼스 마케터 7년차",
		introduction:
			"서비스 중심 B2C부터\n채용/교육/SaaS 분야 B2B까지\n다양한 광고 운영 이력의 전문 마케터",
		tagList: ["솔루션", "교육", "인사/비즈니스"],
		skillList: ["GA/GTM", "마케팅전략", "데이터분석"],
		imageUrl: "/onepoint/assets/images/main/profile/mj.jpg",
		profileUrl: "https://notion.1point.kr/expert/profile/mj",
	},
	// {
	// 	name: "Max",
	// 	job: "PM/PO 5년차",
	// 	introduction:
	// 		"브랜드 운영에 최적화된 이력과\n세일즈&광고 구조화 역량을 갖춘\n올라운더 프로젝트 리더",
	// 	tagList: ["커머스", "뷰티/화장품", "헬스케어/바이오"],
	// 	skillList: ["광고구조화", "콘텐츠기획", "프로젝트리딩"],
	// 	imageUrl: "/onepoint/assets/images/main/profile/son.jpeg",
	// 	profileUrl: "https://notion.1point.kr/expert/profile/max",
	// },
	// {
	// 	name: "Claire",
	// 	job: "그로스 마케터 12년차",
	// 	introduction:
	// 		"글로벌 대기업부터 스타트업까지\n다양한 마케팅 리드 경험으로\n딱 필요한 마케팅 전략을 제시하는 전문가",
	// 	tagList: ["헬스케어/바이오", "컨텐츠/예술", "제조/하드웨어"],
	// 	skillList: ["마케팅전략", "브랜드전략", "SEM"],
	// 	imageUrl: "/onepoint/assets/images/main/profile/claire.jpg",
	// 	profileUrl: "https://notion.1point.kr/expert/profile/claire",
	// },
	{
		name: "hidy",
		job: "그로스 마케터 7년차",
		introduction:
			"유입부터 재구매까지\n비즈니스의 성장에 필요한 A to Z를\n디스커션 할 수 있는 시니어 마케터",
		tagList: ["커머스", "패션", "뷰티/화장품"],
		skillList: ["소재기획", "이미지/영상제작", "콘텐츠기획"],
		imageUrl: "/onepoint/assets/images/main/profile/hidy.jpg",
		profileUrl: "https://notion.1point.kr/expert/profile/hidy",
	},
	// {
	// 	name: "nry",
	// 	job: "퍼포먼스 마케터 4년차",
	// 	introduction:
	// 		"타깃 고객을 겨냥하는 마케팅 기획력과\n디테일한 광고 실무 능력,\n빠른 실행력까지 갖춘 마케팅 전문가",
	// 	tagList: ["모빌리티/교통", "커머스", "물류"],
	// 	skillList: ["네이버", "Meta", "카카오"],
	// 	imageUrl: "/onepoint/assets/images/main/profile/nry.jpg",
	// 	profileUrl: "https://notion.1point.kr/expert/profile/nry",
	// }
];

export const SwiperSectionContents = styled(ContentsContainer)`
	.swiper-pagination {
		position: relative;
		width: 100px !important;
	}

	.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
	.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
		background-color: var(--card-bg);
	}
	.profile-box {
		width: 100%;
		max-width: 1200px;
		overflow: hidden;

		.swiper {
			padding-bottom: 50px;
		}

		.swiper-slide {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.swiper-button-group {
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			width: 40px;
			height: 40px;
			padding-bottom: 100px;
			cursor: pointer;

			svg {
				color: white;
				font-size: 40px;
			}
		}

		@media (max-width: 1200px) {
			.swiper-button-group {
				display: none;
			}

			.review-box {
				padding-left: 0px;
				padding-right: 0px;
			}

			div.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal {
				span.swiper-pagination-bullet-active {
					background: white;
				}
				span.swiper-pagination-bullet {
					width: 20px;
				}
			}
		}

		.swiper-button-prev-unique {
			left: 0px;
		}

		.swiper-button-next-unique {
			right: 0px;
			z-index: 100;
		}

		.swiper-button-prev {
			color: white;
		}

		.swiper-button-next {
			color: white;
		}

		.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal {
			span.swiper-pagination-bullet-active {
				background: white;
			}
			span.swiper-pagination-bullet {
				width: 30px;
				border-radius: 20px;
			}
		}
	}

	.profile-box {
		.swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal {
			span.swiper-pagination-bullet {
				background: black;
			}
		}
	}

	@media screen and (max-width: 500px) {
		.profile-box {
			padding-bottom: 100px;
			padding-left: 30px;
			padding-right: 30px;
		}
	}

	.profile-item {
		display: flex;
		flex-direction: column;
		/* width: 100%; */
		border-radius: 16px;
		position: relative;
		/* background-color: white; */
		border: 1px solid rgba(0, 0, 0, 0.06);
		box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07);
		transition: transform 0.25s ease, box-shadow 0.25s ease;

		&:hover {
			transform: translateY(-6px);
			box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.13);
		}

		.top-box {
			display: flex;
			width: 100%;
			flex-direction: column;
			justify-content: start;
			align-items: start;
			position: relative;
			border-top-right-radius: 40px;
			border-top-left-radius: 40px;
			z-index: 1;
			padding: 0px 25px 0px 25px;
			padding-top: 16px;

			.name {
				color: var(--card-bg);
				font-family: Pretendard;
				font-size: 24px;
				font-style: normal;
				font-weight: 800;
				line-height: 120%; /* 28.8px */
				letter-spacing: -0.96px;
				padding-top: 16px;
			}

			.job {
				color: var(--card-bg);
				font-family: Pretendard;
				font-size: 20px;
				font-style: normal;
				font-weight: 500;
				line-height: 150%; /* 30px */
				letter-spacing: -0.6px;
			}

			.profile-img {
				width: 88px;
				height: 88px;
				border-radius: 100%;
				overflow: hidden;
				object-fit: cover;
			}
		}

		.bottom-box {
			display: flex;
			flex-direction: column;
			justify-content: start;
			align-items: start;
			position: relative;
			flex-wrap: wrap;
			background-color: white;
			border-bottom-right-radius: 40px;
			border-bottom-left-radius: 40px;
			padding: 0px 0px 30px 25px;
			gap: 12px;

			.introduction {
				color: var(--desc-gray);
				font-size: 16px;
				font-style: normal;
				font-weight: 500;
				line-height: 150%; /* 24px */
				letter-spacing: -0.64px;
			}

			.tag-box,
			.skill-box {
				display: flex;
				flex-direction: row;
				justify-content: start;
				align-items: start;
				gap: 0px;
				min-height: 40px;
				flex-wrap: wrap;

				.skill,
				.tag {
					display: flex;
					padding: 0px 0px;
					min-width: fit-content;
					justify-content: center;
					align-items: center;
					gap: 10px;
					color: var(--desc-gray);
					text-align: center;
					font-family: Pretendard;
					font-size: 12px;
					font-style: normal;
					font-weight: 700;
					line-height: 150%; /* 18px */
					letter-spacing: -0.36px;
					padding-right: 14px;
				}
			}

			.go-profile {
				display: flex;
				flex-direction: row;
				justify-content: start;
				align-items: center;
				cursor: pointer;

				> div {
					color: var(--primary);
					font-family: Pretendard;
					font-size: 16px;
					font-style: normal;
					font-weight: 800;
					line-height: 130%; /* 20.8px */
					letter-spacing: -0.64px;
				}
			}
		}
	}

	@media (max-width: 1100px) and (min-width: 800px) {
		.profile-item {
			/* width: 304px;
			height: 304px; */
			* {
				flex-wrap: wrap;
			}

			.top-box {
				.name {
				}

				.job {
				}

				.profile-img {
					top: 25px;
					width: 80px;
					height: 80px;
				}
			}
			.bottom-box {
				.introduction {
					/* font-size: 12px; */
				}
			}
		}
	}

	@media (max-width: 1280px) {
		.profile-item {
			/* width: 304px; */
			/* height: 304px; */

			.top-box {
				.name {
				}

				.job {
				}

				.profile-img {
					/* bottom: -30px;
					width: 60px;
					height: 60px; */
				}
			}
			.bottom-box {
				.introduction {
					/* font-size: 12px; */
				}
			}
		}
	}
`;

export const SubscribeInput = styled.input`
	display: flex;
	padding: 12px 102px 12px 16px;
	align-items: center;
	border-radius: 10px;
	background: #edf0f5;
	flex: 1 0 0;
	border: none;
	color: var(--desc-gray);
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 130%; /* 20.8px */
	letter-spacing: -0.64px;
`;

export const SubscribeButton = styled(LoadingButton)`
	display: flex;
	padding: 12px 16px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	border-radius: 10px;
	background: var(--primary);
	color: #fff;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 800;
	line-height: 130%; /* 20.8px */
	letter-spacing: -0.64px;
	transition: transform 0.2s ease, box-shadow 0.2s ease !important;

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0px 8px 20px 0px rgba(56, 124, 246, 0.4) !important;
	}
`;

export const SectionRight = styled.div`
	flex: 1;
`;

export const FAQButton = styled(Button)`
	display: inline-flex;
	padding: 12px 16px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	border-radius: 10px;
	background: var(--primary);
	color: #fff;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 800;
	line-height: 130%; /* 20.8px */
	letter-spacing: -0.64px;
	transition: transform 0.2s ease, box-shadow 0.2s ease !important;

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0px 8px 20px 0px rgba(56, 124, 246, 0.4) !important;
	}
`;

export const FAQAnswerTitle = styled.div`
	color: var(--card-bg);
	font-size: 20px;
	font-style: normal;
	font-weight: 700;
	line-height: 150%; /* 30px */
	letter-spacing: -0.8px;

	@media screen and (max-width: 1023px) {
		font-size: 16px;
	}
`;

export const AnswerListUl = styled.ul`
	margin-left: 0px;
	padding-left: 20px;
`;

export const FAQAnswerList = styled.li`
	color: var(--desc-gray);
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 24px */
	letter-spacing: -0.64px;
	list-style: disc;
`;

export const ConsultantUserList = [
	{
		imgSrc: "/onepoint/images/consultant/jeon.jpg",
		name: "전준현",
		desc: "퍼포먼스 마케터 2년차",
	},
];

export const CListPagination = styled.div`
	.swiper-pagination-bullet-active {
		background-color: var(--card-bg) !important;
	}
`;

export const CIListContainer = styled.div`
	gap: 8px;
	picture {
		width: calc(25% - 10px);
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		img {
			width: 100%;
		}
	}

	@media screen and (max-width: 1023px) {
		gap: 8px;
		picture {
			width: calc(50% - 10px);
			max-width: 200px;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			img {
				width: 100%;
			}
		}
	}
`;

export const ReviewContainer = styled.div`
	width: 100%;
	max-width: 100%;
	padding: 10px;

	.swiper {
		width: 100%;
		height: auto;
		min-height: 380px;
	}

	.swiper-pagination-bullet-active {
		background-color: var(--card-bg) !important;
	}
`;

export const ReviewData = [
	{
		title: "업계 최고 수준의 마케터를 필요할 때마다 합리적으로",
		description:
			"원포인트는 업계 최고 수준의 마케터를, 필요할 때마다 합리적인 가격으로 활용할 수 있는 서비스입니다.",
		company: "아파트멘터리",
		name: "하아얀",
		position: "전략실장",
		img: "/onepoint/images/renewal/review-section/1-1.png",
	},
	{
		title: "마케팅, 헤매지 않고 시작하는 법",
		description:
			"신규 조직에 내부 전담 인력이 없는 상태에서 GA세팅부터 광고 운영까지, 성공적으로 디지털 마케팅을 시작할 수 있었습니다. 단순 운영 대행이 아닌, 함께 고민하는 파트너와 일하는 것 같아 정말 좋았습니다.",
		company: "한화솔루션",
		name: "김수현",
		position: "프로",
		img: "/onepoint/images/renewal/review-section/1-2.png",
	},
	{
		title: "전문가 퀄리티에 놀랐습니다",
		description:
			"저희가 쉽게 채용할 수 없는 분과, 원하는 기간 만큼만 함께 일할 수 있어서 좋았고 큰 도움을 받았습니다. 특히 전문가 퀄리티에 놀랐습니다.",
		company: "샐러디",
		name: "이건호",
		position: "대표",
		img: "/onepoint/images/renewal/review-section/1-3.png",
	},
	{
		title: "초기 스타트업에게 최고의 선택",
		description:
			"마케터가 필요하지만 정규직 고용은 부담스럽다보니 원포인트를 통해 파트타임 전문가를 고용했습니다. 시간내에 큰 성과를 내기 위해 진심으로 일해주시는 역량있는 마케터를 만나서 많은 도움이 되었습니다.",
		company: "패러닷",
		name: "장진욱",
		position: "대표",
		img: "/onepoint/images/renewal/review-section/1-4.png",
	},
	{
		title: "정규직 채용과 외주 활용 부담을 해결했어요",
		description:
			"정규직을 채용하기에는 제약이 많고, 검증되지 않은 곳에 외주를 맡기기도 부담스러웠습니다. 원포인트를 통해 시간제로 역량있는 마케터와 일할 수 있어 이러한 갈증이 해결되었습니다.",
		company: "셀러노트",
		name: "이종원",
		position: "대표",
		img: "/onepoint/images/renewal/review-section/1-5.png",
	},
	{
		title: "비용이 반으로 줄었는데 성과가 개선됐어요",
		description:
			"마케터 채용 비용의 50%로 실적은 계속적으로 향상되고 있어요! 좋은 시니어 마케터분을 찾으신다면 관리까지 꼼꼼하게 해주는 원포인트 추천합니다!",
		company: "소프트스퀘어드",
		name: "윤수진",
		position: "",
		img: "/onepoint/images/renewal/review-section/1-6.png",
	},
	{
		title: "더 이상 헤매지 않고 마케팅을 하게 되었습니다",
		description:
			"마케팅은 경험이 중요하다고 생각합니다. 고급 숙련자의 경험을 바탕으로 마케팅을 진행하고 배울 수 있어서 추천합니다. 더 이상 주니어들끼리 헤매지 않아도 됩니다.",
		company: "투어라이브",
		name: "노경아",
		position: "대표",
		img: "/onepoint/images/renewal/review-section/1-7.png",
	},
	{
		title: "광고 성과가 많이 올랐습니다",
		description:
			"실력있는 인재와 함께하는 것이 좋은 성과의 핵심인데, 원포인트에서 만난 마케팅 전문가님의 도움으로 성과가 많이 올랐습니다",
		company: "펫박스",
		name: "이현석",
		position: "대표",
		img: "/onepoint/images/renewal/review-section/1-8.png",
	},
	{
		title: "더 이상 대행사를 쓰지 않습니다",
		description:
			"마케팅 대행사를 세 곳 정도 써보았지만 모두 마음에 들지 않았습니다. 결국 지금은 원포인트를 통해 숙련된 퍼포먼스 마케터를 파트타임으로 활용하고 있는데, 알아서 캠페인 퍼포먼스 관리를 잘 해주시니 정말 편리합니다.",
		company: "에딧메이트",
		name: "최범익",
		position: "대표",
		img: "/onepoint/images/renewal/review-section/1-9.png",
	},
];

export const ExpertReviewData = [
	{
		title: "원포인트와 함께\n새로운 도전을 하고 있어요",
		description:
			"원포인트로 얻는 수익이 안정적인데다가 제 커리어와 fit한 신규 고객사를 꾸준히 제안주시다보니, 용기내어 퇴사를 결심할 수 있게 되었어요. 제가 편한 시간에 자유롭게 근무할 수 있음에 감사하고 있어요.",
		position: "퍼포먼스 마케터",
		name: "Day",
	},
	{
		title: "관심있는 분야의 \n스타트업을 경험했어요",
		description:
			"프롭테크에 관심이 많아서 이직을 고려하고 있었어요. 이 점을 고려해서 매칭을 해달라고 부탁드렸었고, 정말 관련 스타트업과 일할 수 있었습니다.",
		position: "브랜드 마케터",
		name: "자몽",
	},
	{
		title: "초기 스타트업을 성장시키는 \n뿌듯함을 느끼고 있어요",
		description:
			"규모가 큰 회사에 다니다 보니까 매번 똑같은 일만 하고 있었는데요. 원포인트를 통해서 초기 스타트업을 도와드리게 되었어요. 저를 통해 비즈니스가 성장하는 걸 보면 정말 보람있습니다.",
		position: "그로스 마케터",
		name: "Ryan",
	},
	{
		title: "제가 가진 스킬로\n부수입을 만들고 있어요",
		description:
			"원래 제가 잘 알고 있는 스킬들을 활용하여 추가 수입을 만들 수 있다는 것이 가장 큰 장점입니다. 또한, 다양한 업계의 클라이언트를 만날 수 있어서 더 많은 경험을 통한 인사이트를 쌓을 수 있습니다.",
		position: "퍼포먼스 마케터",
		name: "루시",
	},
	{
		title: "확신을 가지고 프리랜서로\n전향할 수 있었습니다",
		description:
			"늘 디지털 노마드가 되는게 목표였습니다. 그러다가 원포인트를 만났습니다. 조금씩 담당하는 고객사를 늘리다가 이제는 아예 프리랜서로 전향했습니다.",
		position: "카피라이터",
		name: "Zero",
	},
	{
		title: "원포인트 덕에\n편하게 사이드잡을!",
		description:
			"저에게 딱 맞는 고객사분들 추천해주셔서 마음껏 마케팅 일하고 돈벌고 있습니다. 원포인트가 있어서 안심하고 있으며 편하게 사이드잡합니다! 계속해서 고객사와 마케터를 연결해주는 좋은 플랫폼으로 남아주세요!",
		position: "퍼포먼스 마케터",
		name: "유진",
	},
	{
		title: "제 가치를\n인정 받고 있어요",
		description:
			"디자인 시장은 워낙 저렴한 가격에 진행하는 곳이 많아서 돈을 많이 벌 수 없었어요. 하지만 원포인트의 전문가는 기본적으로 고객사가 신뢰하고 있어서 제 가치에 맞는 보수를 받을 수 있었습니다.",
		position: "디자이너",
		name: "Ace",
	},
	{
		title: "다양한 업무 경험에\n부수입까지!",
		description:
			"다양한 업종의 마케팅을 경험할 수 있고, 자신이 노력한 한 만큼 부수입도 얻을 수 있어 일이 재미있다고 느끼실 수 있을 것 같아요. 주어지는 회사 업무만으로 만족하지 못하는, 열정이 넘치는 마케터들에게 적극 추천합니다.",
		position: "마케팅 디렉터",
		name: "하슬기",
	},
	{
		title: "고객사와 마케터를 위한\n가장 합리적 선택입니다",
		description:
			"고객사분들께서는 마케터를 고용하기에는 높은 임금이 부담스러운 문제를 해결해주고, 대행사 및 인하우스 마케터는 원포인트를 통해 다양한 브랜드 경험과 함께 부가적인 수익을 얻으면서 자부심까지 상승하는 것 같습니다.",
		position: "퍼포먼스 마케터",
		name: "범쌤",
	},
	{
		title: "다양한 프로젝트를 통해\n포트폴리오가 풍부해졌어요",
		description:
			"회사 업무 외에도 다양한 프로젝트를 맡아 진행할 수 있어 부족한 포트폴리오를 채우는 데 도움이 많이 됩니다. 특히 고객사들이 초기 스타트업들이 많아 제 의견을 적극적으로 수용해주셔서 하고 싶은 프로젝트를 재미있게 하고 있어요.",
		position: "콘텐츠 마케터",
		name: "Yonna",
	},
	{
		title: "최적의 업무 환경에서\n일할 수 있어요",
		description:
			"재택으로 일할 수 있는 점이 가장 큰 매력이에요. 또한 업무 시간, 협업 방식 역시 유연하게 조정할 수 있어서 업무 생산성도 높아지는 것 같습니다. 마케터에게는 최적의 업무 환경인 것 같아요.",
		position: "마케팅 디렉터",
		name: "클레어",
	},
	{
		title: "타서비스 대비 \n매칭 만족도가 높아요",
		description:
			"원포인트는 내가 가진 전문역량을 활용하여 높은 수준의 부수입을 만들 수 있는 가장 쉬운 방법입니다. 타서비스와 비교할 수 없을 만큼 고객사의 니즈를 구체적으로 전달해주시고 빠르게 소통해주셔서 매칭 만족도와 성사율도 높습니다.",
		position: "그로스 마케터",
		name: "레비",
	},
];

export const ExpertTrustCard = styled.div`
	display: flex;
	width: 320px;
	padding: 40px 20px;
	flex-direction: column;
	align-items: flex-start;
	gap: 10px;
	border-radius: 4px;
	/* background: #f8f9fb; */

	.title {
		color: var(--desc-gray);
		text-align: center;
		font-family: Pretendard;
		font-size: 20px;
		font-style: normal;
		font-weight: 700;
		line-height: 150%; /* 36px */
		letter-spacing: -0.96px;
		width: 100%;
	}

	.num {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 40px;
		font-style: normal;
		font-weight: 800;
		line-height: 116%; /* 55.68px */
		letter-spacing: -1.92px;
	}

	.numstr {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 32px;
		font-style: normal;
		font-weight: 800;
		line-height: 130%; /* 41.6px */
		letter-spacing: -1.28px;
	}

	.desc {
		color: var(--desc-gray);
		text-align: center;
		font-family: Pretendard;
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 30px */
		letter-spacing: -0.8px;
		width: 100%;
	}

	@media (max-width: 1023px) {
		padding: 30px 20px;
		.title {
			font-size: 20px;
		}

		.num {
			font-size: 32px;
		}

		.numstr {
			font-size: 32px;
		}

		.desc {
			font-size: 20px;
		}
	}
`;

export const TrustData = [
	{
		title: "국내 프리랜서 마케터 플랫폼",
		num: "1",
		numstr: "위",
		// dest: "전문가를 1회 이상 고용한 고객사 수",
	},
	{
		title: "원포인트 전문가 월 평균 수입",
		num: "264만원",
		numstr: "+",
		// dest: "3단계 검증을 거쳐 합격한 전문가 수",
	},
	{
		title: "원포인트와 함께하는 전문가",
		num: "800명",
		numstr: "+",
		// dest: "매월 계약을 연장하는 기업의 비율",
	},
];

export const BpCard = styled.div`
	width: calc(33% - 8px);
	flex-shrink: 0;
	border-radius: 16px;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	cursor: pointer;
	box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07);
	transition: transform 0.25s ease, box-shadow 0.25s ease;

	&:hover {
		transform: translateY(-6px);
		box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.13);
	}

	.img {
		width: 100%;
	}

	.title {
		color: var(--card-bg);
		font-size: 19px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 26px */
		letter-spacing: -0.6px;
	}

	.card {
		display: inline-flex;
		padding: 4px 8px;
		justify-content: center;
		align-items: center;
		gap: 10px;
		border-radius: 4px;
		background: var(--bg-white);
		color: var(--desc-gray);
		text-align: center;
		font-family: Pretendard;
		font-size: 12px;
		font-style: normal;
		font-weight: 700;
		line-height: 150%; /* 18px */
		letter-spacing: -0.36px;
	}
`;

export const BpList = [
	{
		name: "마케팅 캠페인",
		title: "샐러디는 어떻게 배달앱 인기 검색어 1위에 올랐을까?",
		imgSrc: "/onepoint/assets/images/main/example/bp_salady.png",
		url: "https://1point.kr/blog/best-practices/salady/",
	},
	{
		name: "콘텐츠 마케팅",
		title: "580억 투자 받은 아파트멘터리가 잘하는 마케터 고용한 방법",
		imgSrc: "/onepoint/assets/images/main/example/bp_ap.png",
		url: "https://1point.kr/blog/best-practices/apartmentary/",
	},
	{
		name: "콘텐츠 마케팅",
		title: "MZ세대 대세 서비스 패러닷이\n대박 콘텐츠를 만들어낸 노하우",
		imgSrc: "/onepoint/assets/images/main/example/paradot.png",
		url: "https://1point.kr/blog/best-practices/paradot/",
	},
	{
		name: "퍼포먼스 마케팅",
		title: "트렌드아이는 어떻게 마케터 채용에\n드는 시간과 비용을 줄였을까?",
		imgSrc: "/onepoint/assets/images/main/example/bp_wdressroom.png",
		url: "https://1point.kr/blog/best-practices/trend-i/",
	},
	{
		name: "그로스 마케팅",
		title: "초기 스타트업 리클이\n경력직 마케터 채용 대신 선택한 것",
		imgSrc: "/onepoint/assets/images/main/example/bp_recl.png",
		url: "https://1point.kr/blog/best-practices/recl/",
	},
	{
		name: "브랜드 마케팅",
		title: "닥터이브가 마케터 정규직 없이\n3개월만에 매출 월 1억을 달성한 방법",
		imgSrc: "/onepoint/assets/images/main/example/purposed-dreve.png",
		url: "https://1point.kr/blog/best-practices/purposed-dreve/",
	},
];

export const BigInsightCard = styled.div`
	width: 440px;
	height: 564px;
	flex-shrink: 0;
	border-radius: 16px;
	overflow: hidden;
	border: 1px solid rgba(0, 0, 0, 0.06);
	background: #fff;
	flex-grow: 0;
	flex-shrink: 0;
	cursor: pointer;
	box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07);
	transition: transform 0.25s ease, box-shadow 0.25s ease;

	&:hover {
		transform: translateY(-6px);
		box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.13);
	}

	.thumb {
		width: 440px;
		flex-shrink: 0;
	}

	.tag {
		display: inline-flex;
		padding: 4px 8px;
		justify-content: center;
		align-items: center;
		gap: 10px;
		border-radius: 4px;
		background: var(--bg-white);
		color: var(--desc-gray);
		text-align: center;
		font-family: Pretendard;
		font-size: 12px;
		font-style: normal;
		font-weight: 700;
		line-height: 150%; /* 18px */
		letter-spacing: -0.36px;
	}

	.title {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 16px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 20.8px */
		letter-spacing: -0.48px;
	}

	.name {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 12px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 18px */
		letter-spacing: -0.48px;
	}
	.text {
		color: var(--desc-gray);
		font-size: 20px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 30px */
		letter-spacing: -0.8px;
	}
`;

export const InsightCard = styled.div`
	width: 260px;
	height: 280px;
	flex-shrink: 0;
	border-radius: 16px;
	overflow: hidden;
	border: 1px solid rgba(0, 0, 0, 0.06);
	background: #fff;
	cursor: pointer;
	box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07);
	transition: transform 0.25s ease, box-shadow 0.25s ease;

	&:hover {
		transform: translateY(-6px);
		box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.13);
	}

	.thumb {
		width: 260px;
		flex-shrink: 0;
	}

	.tag {
		display: inline-flex;
		padding: 4px 8px;
		justify-content: center;
		align-items: center;
		gap: 10px;
		border-radius: 4px;
		background: var(--bg-white);
		color: var(--desc-gray);
		text-align: center;
		font-family: Pretendard;
		font-size: 12px;
		font-style: normal;
		font-weight: 700;
		line-height: 150%; /* 18px */
		letter-spacing: -0.36px;
	}

	.title {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 16px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 20.8px */
		letter-spacing: -0.48px;
	}

	.name {
		color: var(--card-bg);
		font-family: Pretendard;
		font-size: 12px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 18px */
		letter-spacing: -0.48px;
	}
`;

export const InsightList = [
	{
		name: "연준현",
		title: "초기 스타트업을 위한 마케팅 가이드",
		type: "인사이트",
		imgSrc: "/onepoint/images/renewal/insight-section/1.png",
		url: "https://1point.kr/blog/insights/startup-marketing-guide/",
		text: "초기 스타트업, 어떤 마케팅을 해야 할까요? 라이브 커머스, SEO/SEM, 퍼포먼스, 그로스, 브랜드, 이메일, CPA, 트래픽, 제휴, 콘텐츠 등 이 많은 마케팅 방법 중 초기 스타트업은 어떤 것을 선택해야 할지 목적과 수단에 따른 마케팅에 대해 알아봅니다.",
	},
	{
		name: "레비",
		title: "개발 지식 없이 페이스북 픽셀\n설치하는 법",
		type: "인사이트",
		imgSrc: "/onepoint/images/renewal/insight-section/2.png",
		url: "https://1point.kr/blog/insights/meta-pixel-1/",
	},
	{
		name: "데이",
		title: "인스타 광고 vs 메타 광고\n3가지 차이점 탐구",
		type: "인사이트",
		imgSrc: "/onepoint/images/renewal/insight-section/3.png",
		url: "https://1point.kr/blog/insights/instagram-vs-meta/",
	},
	{
		name: "콘텐츠온",
		title: "B2B 마케팅에서 고객을\n효과적으로 설득하는 방법",
		type: "인사이트",
		imgSrc: "/onepoint/images/renewal/insight-section/4.png",
		url: "https://1point.kr/blog/insights/b2b-success-cases/",
	},
	{
		name: "Miguel",
		title: "퍼포먼스 마케팅 vs 그로스 마케팅,\n차이점과 적용 시기",
		type: "인사이트",
		imgSrc: "/onepoint/images/renewal/insight-section/5.png",
		url: "https://1point.kr/blog/insights/growth-performance-difference/",
	},
];

export const CustomAccordion = styled(Accordion)`
	border: none;
	background-color: white;
	width: 100%;
	transition: all 0.2s ease-in-out;

	&:hover {
		background-color: #f5f5f5;
	}

	&.MuiAccordion-root {
		&:before {
			background-color: transparent !important;
		}
	}

	@media screen and (max-width: 1023px) {
		.MuiAccordionSummary-root {
			font-size: 14px;
		}
	}
`;

export const PentagonSubTitle = styled.div`
	color: var(--card-bg);
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 120%; /* 19.2px */
	letter-spacing: -0.48px;
`;

export const PentagonTitle = styled.div`
	color: var(--card-bg);
	text-align: right;
	font-family: Pretendard;
	font-size: 40px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%; /* 48px */
	letter-spacing: -1.2px;
`;

export const PentagonTitle2 = styled.div`
	color: var(--card-bg);
	text-align: right;
	font-family: Pretendard;
	font-size: 24px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%; /* 28.8px */
	letter-spacing: -0.72px;
`;

export const HowToVerifyStepTitle = styled.div`
	color: var(--desc-gray);
	font-family: Pretendard;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 130%; /* 19.2px */
	letter-spacing: -0.64px;
`;

export const HowToVerrifyBigTitle = styled.div`
	color: var(--card-bg);
	font-size: 40px;
	font-style: normal;
	font-weight: 800;
	line-height: 120%;
	letter-spacing: -2.24px;

	.blue {
		color: #387cf6;
	}
`;

export const CustomA = styled.a`
	color: black;
	font-size: 14px;
	cursor: pointer;

	&:hover {
		color: #0378ef !important;
	}
`;

export const ExpertWhyOnpointData = [
	{
		label: "수익 창출",
		title: (
			<>
				<span className="bold">잘하는 일</span>로<br />
				<span className="bold">부수입</span>을 만드세요
			</>
		),
		description: "그동안 힘들게 쌓아오신 역량을\n수익화 할 수 있는 기회입니다",
		image: "/onepoint/images/renewal/expert/why-section/money.png",
	},
	{
		label: "유연함",
		title: (
			<>
				잘 맞는 고객사와
				<br />
				<span className="bold">원하는 업무만 하세요</span>
			</>
		),
		description: "프로필 전체 공개없이\n희망하는 업무만 골라 지원할 수 있습니다",
		image: "/onepoint/images/renewal/expert/why-section/match.png",
	},
	{
		label: "다양한 경험",
		title: (
			<>
				<span className="bold">본업 외 분야</span>에서
				<br />
				<span className="bold">성과</span>를 만드세요
			</>
		),
		description: "본업 외 분야에 새롭게 도전하며\n자극받고 성장할 수 있습니다",
		image: "/onepoint/images/renewal/expert/why-section/mountain.png",
	},
];

export const ResponsibilityData = [
	{
		title: "전문가 개인 정보는\n철저하게 지켜요",
		desc: "닉네임 사용, 전문가 동의 없이\n신상정보 미공개, 비밀유지 NDA 체결",
		image: "/onepoint/images/renewal/expert/why-section/lock.png",
	},
	{
		title: "번거로운 작업은\n원포인트가 책임질게요",
		desc: "계약, 단가 협의, 일정 변경, 사후 조율 등의 물리적, 심리적으로 부담스러운 업무",
		image: "/onepoint/images/renewal/expert/why-section/cal.png",
	},
	{
		title: "전문가 대금은\n안전하게 지급해요",
		desc: "대금 선수취로 미지급 걱정 없이 정해진\n일자에 약속된 대금 지급",
		image: "/onepoint/images/renewal/expert/why-section/calendar.png",
	},
];

export const ResponsibilityCard = styled.div`
	gap: 8px;
	flex-basis: calc(33% - 19px);

	.responsibility-img {
		width: 56px;
		height: 56px;
	}

	.title {
		color: var(--card-bg);
		font-size: 24px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%; /* 31.2px */
		letter-spacing: -0.72px;
		letter-spacing: -0.48px;
	}

	.desc {
		color: var(--desc-gray);
		font-size: 20px;
		font-style: normal;
		font-weight: 500;
		line-height: 150%; /* 30px */
		letter-spacing: -0.8px;
	}

	@media screen and (max-width: 1024px) {
		width: 100%;
		max-width: 300px;

		.title {
			font-size: 20px;
		}
		.desc {
			font-size: 16px;
		}
	}
`;
